import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useGetOpenIdAuthenticateQuery } from '../api/appAPI';
import { LoaderComponent } from './LoaderComponent';

interface LoginOpenIDProps {
}

export const LoginOpenID: React.FC<LoginOpenIDProps> = (props) => {

  const {data, isLoading, error } = useGetOpenIdAuthenticateQuery();
  
  const handleClick = () => {
      if(data) {
        document.location = data.redirect_url;
      }
  };

  return(
    <Card className="border rounded p-2 m-2 mx-auto">
      <h1>You need to authenticate</h1>
      <LoaderComponent error={error} isLoading={isLoading}/>
      { data ? <div>
                <p>You ar going to be redirected to the authentication server. Please click on the button below to authenticate</p>
                <Button variant="primary" type="submit" onClick={handleClick}>Connect</Button> 
                </div>
      : ''}
    </Card>
  )
}

